// extracted by mini-css-extract-plugin
export default {"skillsIcons":"Skills_skillsIcons__BMecd"};